export default __webpack_public_path__ + "locales/ro/MainBar.json?hash=d9586f867c585b2362f89f247932a843";